import React from 'react';
import styles from './AppHeader.module.css';

export interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  label: string;
  badge?: number;
}

export const IconButton: React.FC<IconButtonProps> = ({
  label,
  badge,
  children,
  className,
  ...rest
}) => (
  <button type="button" className={`${styles.iconBtn} ${className ?? ''}`} aria-label={label} {...rest}>
    {children}
    {badge != null && badge > 0 ? <span className={styles.iconBadge}>{badge > 99 ? '99+' : badge}</span> : null}
  </button>
);
